import React from 'react'

import { Form, Col } from '_zari/core'

const NombreSocioFormGroup = ({ value }) => {
  return (
    <Form.Group>
      <Form.Label text='CLIENTE' htmlFor='input-nombreSocio' md={4} />
      <Col md={8}>
        <Form.InputText value={value} disabled id='input-nombreSocio' />
      </Col>
    </Form.Group>
  )
}

export default NombreSocioFormGroup
